<template>
    <div class="time-picker" v-disabled="disabled">
        <icon name="menu-left" @click="decrease"/>
        <input type="text" :id="id" class="form-control" v-c:form-control-sm="small" :value="time" ref="input" @focus="onFocus" @blur="onBlur">
        <icon name="menu-right" @click="increase"/>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            value: String,
            id: {required: false, type: String},
            default: {type: String, default: '00:00'},
            allowEmpty: {type: Boolean, default: true},
            inputFormat: {type: String, default: 'HH:mm'},
            displayFormat: {type: String, default: 'HH:mm'},
            small: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            min: {type: String, default: null},
            max: {type: String, default: null},
        },

        data() {
            return {
                lastValidDate: this.value,
            };
        },

        computed: {
            timeObject() {
                return moment(this.value || this.getDefault(), this.inputFormat);
            },

            time: {
                get() {
                    if (this.value === '' || this.value === null) {
                        return null;
                    }
                    return this.timeObject.format(this.displayFormat);
                },
                set(value) {
                    if (value === "") {
                        this.$emit('input', this.allowEmpty ? null : this.getDefault());
                    } else {
                        let time = moment(value, this.displayFormat);
                        if (!time.isValid()) {
                            time = moment(this.lastValidDate, this.inputFormat);
                        }
                        this.$emit('input', time.format(this.inputFormat));
                        this.lastValidDate = time.format(this.inputFormat);
                        this.$forceUpdate();
                    }
                },
            },
        },

        methods: {
            getDefault() {
                if (this.default === 'now') {
                    return moment().format(this.displayFormat);
                }
                return moment(this.default, this.inputFormat).format(this.displayFormat);
            },

            onFocus() {
                if (this.time === '' || this.time === null) {
                    this.time = this.default;
                }
            },

            onBlur() {
                this.time = this.$refs.input.value;
            },

            decrease() {
                this.time = this.timeObject.subtract(1, 'hours').format(this.inputFormat);
            },

            increase() {
                this.time = this.timeObject.add(1, 'hours').format(this.inputFormat);
            },
        },
    };
</script>